export default "/images/b3052ba77bbd79a7b3b28c87d744ec94.avif";